<template>
    <div class="row">

        <!-- IMAGE -->
        <div v-if="typeof selectedApron !== 'undefined' && selectedApron !== null" class="col-12 col-md-5 col-lg-5 d-none d-md-none d-lg-block">

            <apron-preview v-if="selectedApron.model.setWith == -1" :configured-apron="selectedApron" :configured-skirt="null" :color-warnings="colorWarnings" class="item-preview"></apron-preview>
            <apron-preview v-else-if="selectedApron.model.setWith > -1 && selectedApron.model.setWith < selectedApron.model.apronModelID" :configured-apron="null" :configured-skirt="selectedApron" :color-warnings="colorWarnings" class="item-preview"></apron-preview>
            <apron-preview v-else-if="selectedApron.model.setWith > -1 && selectedApron.model.setWith > selectedApron.model.apronModelID" :configured-apron="selectedApron" :configured-skirt="null" :color-warnings="colorWarnings" class="item-preview"></apron-preview>
        </div>

        <!-- DETAILS -->
        <div v-if="typeof selectedApron !== 'undefined' && selectedApron !== null" class="col-12 col-md-12 col-lg-7">
            <apron-detail :selected-apron="selectedApron"></apron-detail>
            <navigation-button mode="custom" :allow-press="true" @button-clicked="OpenEditModal(selectedApron.apronID)" static-icon="pen-fill" :text="$t('previewPlusDetails.editDetails')" class="mt-4 mb-4"></navigation-button>
        </div>
        <div v-else>
            <p>
                <i18n path="previewPlusDetails.apronNotFound" tag="label" for="previewPlusDetails.returnToDashboard">
                    <router-link :to="{ name: 'DashboardHome' }" class="text-decoration-none">{{ $t('previewPlusDetails.returnToDashboard') }}</router-link>
                </i18n>
            </p>
        </div>
    </div>
</template>

<script>
    import Bus from '@/Bus.js';
	import ApronDetail from "@/private/components/UI-elements/ApronDetail.vue";
	import ApronPreview from '@/private/components/Configurator/ApronPreview.vue'
    import AddEditApron from '@/private/components/ModalContent/AddEditApron.vue'
	import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import * as general from '@/scripts/General.js';

    export default {
        name: 'PreviewPlusDetails',
        props: {
            value: Object

        },
        components: {
            ApronDetail,
            ApronPreview,
            NavigationButton
        },
        data: function () {

            return {
                selectedApron: this.value
            }

        },
        mounted: function () {
            Bus.$on('apron-saved', (newData) => { this.selectedApron = newData })

			//Check if ribbons are available at all
			this.$store.dispatch('GET_ApronColorsByModelID', this.selectedApron.model.apronModelID)
        },
        destroyed: function () {
            Bus.$off('apron-saved')
        },
        methods: {
            OpenEditModal(MyApronID) {
                var objProps = {
                    apronID: [MyApronID]
                }

                if (MyApronID > 0) {
                    Bus.$emit('set-modal-data', objProps, AddEditApron, 'Edit apron');
                } else {
                    Bus.$emit('set-modal-data', objProps, AddEditApron, 'Add apron');
                }

                Bus.$emit('open-modal');

            },
            SizeToString: general.SizeToString,
            toHTML5date: general.toHTML5date
        },
        computed: {
            colorWarnings() {
                if (this.selectedApron.model.manufacturerID != 1) {
                    return ''
                }

                //Colours
                if (this.selectedApron.model.category == 3) {
                    if (this.selectedApron.fabricColorID == null) {
						return this.$t('previewPlusDetails.fabricColorUnknown')
                    } else {
                        return ''
                    }
                }

                //Apron
                if (this.selectedApron.fabricColorID == null && this.selectedApron.ribbonColorID == null) {
					return this.$t('previewPlusDetails.fabricAndRibbonColorUnknown')
                } else if (this.selectedApron.fabricColorID == null) {
					return this.$t('previewPlusDetails.fabricColorUnknown')
				} else if (this.selectedApron.ribbonColorID == null && this.$store.state.lstRibbonColors.length != 0) {
					return this.$t('previewPlusDetails.ribbonColorUnknown')
                } else {
                    return ''
                }
            },
        },
        watch: {
            
			selectedApron: {
				deep: true,
				handler: function (newValue) {
					//v-model outwards
					this.$emit('input', newValue)

				}
            },
			value: function (newValue) {
				//v-model-inward
				this.selectedApron = newValue
			},
        }
    }
</script>
